export default __webpack_public_path__ + "static/media/paper.e2f77f9d.png";